export default {"src":"/_next/static/media/error.e2bfba35.svg","height":1380,"width":1840,"blurWidth":0,"blurHeight":0};